import { DropDownOption } from '@aibees/shared/components';
import { CompanyStats } from '../../types';
import * as SX from './sx';

export const STATS_OPTIONS: DropDownOption[] = [
  {
    key: 'employee',
    value: CompanyStats.Employee,
    label: CompanyStats.Employee,
    startIcon: 'people-group',
    startIconSx: SX.employeeIcon,
  },
  {
    key: 'office',
    value: CompanyStats.Office,
    label: CompanyStats.Office,
    startIcon: 'business',
    startIconSx: SX.officeIcon,
  },
];
